import { GetNovosCadastrosMesAtual } from '@services/api/api.correspondencia';
import { Card, Spin, Statistic } from 'antd';
import { FolderTwoTone } from '@ant-design/icons';

interface Props {
  mes: moment.Moment;
}
function DashboardNovosCadastrosMesAtual({ mes }: Props) {
  const { data, isLoading } = GetNovosCadastrosMesAtual(mes);

  return (
    <Card>
      <Spin spinning={isLoading}>
        <Statistic
          title="Novos Cadastros no Mês"
          value={data}
          precision={0}
          style={{ width: 500, height: 62 }}
          valueStyle={{ color: 'green' }}
          prefix={<FolderTwoTone twoToneColor="green" />}
        />
      </Spin>
    </Card>
  );
}

export default DashboardNovosCadastrosMesAtual;
